
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function GetInvolved() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-20 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/15d315e4534d0283d778612fd4c29266.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-green-900/80 to-blue-900/70"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Join Our <span className="text-yellow-300">Movement</span>
            </h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto leading-relaxed">
              Every branch of our tree of support grows stronger with your involvement. Together, we can create lasting change in our community.
            </p>
          </div>
        </div>
      </section>

      {/* Ways to Get Involved */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Ways to Make a Difference</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Whether you have time, resources, or expertise to share, there's a place for you in our community of change-makers.
            </p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-emerald-50 to-green-100 rounded-xl p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-20 h-20 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-hand-heart-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Donate</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Your financial support directly funds housing, employment programs, mental health services, and case management for those who need it most.
              </p>
              <Button variant="primary" size="lg" className="w-full">
                <i className="ri-gift-line mr-2"></i>
                Make a Donation
              </Button>
            </div>
            
            <div className="bg-gradient-to-br from-blue-50 to-indigo-100 rounded-xl p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-team-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Volunteer</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Share your time and skills to directly support our programs, mentor participants, or help with administrative tasks and special events.
              </p>
              <Button variant="primary" size="lg" className="w-full">
                <i className="ri-user-add-line mr-2"></i>
                Become a Volunteer
              </Button>
            </div>
            
            <div className="bg-gradient-to-br from-purple-50 to-pink-100 rounded-xl p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-20 h-20 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-building-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Partner</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Organizations and businesses can partner with us to provide employment opportunities, services, or resources that support our mission.
              </p>
              <Button variant="primary" size="lg" className="w-full">
                <i className="ri-handshake-line mr-2"></i>
                Explore Partnership
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Donation Impact */}
      <section className="py-20 bg-gradient-to-br from-emerald-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Your Donation Impact</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              See exactly how your contribution creates lasting change in someone's life and strengthens our entire community.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-lg text-center">
              <div className="text-3xl font-bold text-emerald-600 mb-2">$50</div>
              <h4 className="font-semibold text-gray-900 mb-3">Emergency Support</h4>
              <p className="text-gray-600 text-sm">Provides emergency food and basic necessities for one person for a week</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg text-center">
              <div className="text-3xl font-bold text-blue-600 mb-2">$150</div>
              <h4 className="font-semibold text-gray-900 mb-3">Job Training</h4>
              <p className="text-gray-600 text-sm">Funds vocational training materials and certification costs for one individual</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg text-center">
              <div className="text-3xl font-bold text-purple-600 mb-2">$300</div>
              <h4 className="font-semibold text-gray-900 mb-3">Mental Health Care</h4>
              <p className="text-gray-600 text-sm">Covers one month of individual therapy sessions with our licensed counselors</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg text-center">
              <div className="text-3xl font-bold text-orange-600 mb-2">$500</div>
              <h4 className="font-semibold text-gray-900 mb-3">Housing Stability</h4>
              <p className="text-gray-600 text-sm">Helps with security deposits and first month's rent for permanent housing</p>
            </div>
          </div>
          
          <div className="mt-12 bg-white rounded-xl p-8 shadow-lg">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Monthly Giving Program</h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Join our Tree of Hope monthly giving program and provide sustained support that allows us to plan long-term services and create lasting change. Monthly donors receive quarterly impact reports and exclusive updates from our programs.
                </p>
                <div className="flex space-x-4">
                  <Button variant="primary">
                    Monthly Giving
                  </Button>
                  <Button variant="outline">
                    One-Time Gift
                  </Button>
                </div>
              </div>
              <div 
                className="rounded-lg h-64 bg-cover bg-center"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=Tree%20of%20hope%20with%20heart-shaped%20leaves%20growing%20from%20coins%20and%20donations%2C%20symbolic%20representation%20of%20giving%20creating%20growth%20and%20positive%20change%2C%20warm%20golden%20lighting%2C%20metaphor%20for%20philanthropic%20impact%2C%20inspiring%20and%20uplifting%20charitable%20giving%20theme&width=600&height=400&seq=donation-impact&orientation=landscape')`,
                  backgroundPosition: 'center top'
                }}
              ></div>
            </div>
          </div>
        </div>
      </section>

      {/* Volunteer Opportunities */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Volunteer Opportunities</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Use your unique skills and experience to directly support individuals on their journey to stability and independence.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div className="bg-blue-50 rounded-lg p-6 border-l-4 border-blue-500">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-heart-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Peer Mentors</h4>
                    <p className="text-gray-700 text-sm mb-2">Support individuals with lived experience through one-on-one mentoring relationships.</p>
                    <p className="text-blue-600 text-sm font-medium">Commitment: 4 hours/month • Training provided</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-emerald-50 rounded-lg p-6 border-l-4 border-emerald-500">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-briefcase-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Employment Coaches</h4>
                    <p className="text-gray-700 text-sm mb-2">Help participants develop job skills, create resumes, and practice interviews.</p>
                    <p className="text-emerald-600 text-sm font-medium">Commitment: 6 hours/month • Professional experience preferred</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-purple-50 rounded-lg p-6 border-l-4 border-purple-500">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-graduation-cap-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Educational Support</h4>
                    <p className="text-gray-700 text-sm mb-2">Tutor participants in basic education, GED preparation, or computer skills.</p>
                    <p className="text-purple-600 text-sm font-medium">Commitment: 3 hours/week • Teaching experience helpful</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="space-y-6">
              <div className="bg-orange-50 rounded-lg p-6 border-l-4 border-orange-500">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-calendar-event-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Event Support</h4>
                    <p className="text-gray-700 text-sm mb-2">Help with fundraising events, community outreach, and program celebrations.</p>
                    <p className="text-orange-600 text-sm font-medium">Commitment: Flexible • Perfect for groups</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-pink-50 rounded-lg p-6 border-l-4 border-pink-500">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-pink-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-palette-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Creative Programs</h4>
                    <p className="text-gray-700 text-sm mb-2">Lead art therapy, music sessions, or other creative wellness activities.</p>
                    <p className="text-pink-600 text-sm font-medium">Commitment: 2 hours/week • Creative background preferred</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-6 border-l-4 border-gray-500">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gray-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-file-text-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Administrative Support</h4>
                    <p className="text-gray-700 text-sm mb-2">Assist with data entry, filing, newsletter preparation, and office tasks.</p>
                    <p className="text-gray-600 text-sm font-medium">Commitment: 4 hours/month • Remote options available</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="mt-12 text-center">
            <Button variant="primary" size="lg">
              <i className="ri-user-add-line mr-2"></i>
              Apply to Volunteer
            </Button>
          </div>
        </div>
      </section>

      {/* Partnership Opportunities */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Partnership Opportunities</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Partner with us to create systemic change and expand our impact throughout the community.
            </p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-building-2-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Corporate Partners</h3>
              <ul className="space-y-3 text-gray-700 mb-6">
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-blue-600 mt-1"></i>
                  <span>Employment opportunities for participants</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-blue-600 mt-1"></i>
                  <span>Skills training and apprenticeship programs</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-blue-600 mt-1"></i>
                  <span>Volunteer opportunities for employees</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-blue-600 mt-1"></i>
                  <span>Sponsored fundraising events</span>
                </li>
              </ul>
              <Button variant="primary" className="w-full">
                <i className="ri-handshake-line mr-2"></i>
                Corporate Partnership
              </Button>
            </div>
            
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-hospital-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Healthcare Partners</h3>
              <ul className="space-y-3 text-gray-700 mb-6">
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-emerald-600 mt-1"></i>
                  <span>Integrated mental health services</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-emerald-600 mt-1"></i>
                  <span>Substance abuse treatment programs</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-emerald-600 mt-1"></i>
                  <span>Medical care coordination</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-emerald-600 mt-1"></i>
                  <span>Health education workshops</span>
                </li>
              </ul>
              <Button variant="primary" className="w-full">
                <i className="ri-stethoscope-line mr-2"></i>
                Healthcare Partnership
              </Button>
            </div>
            
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-community-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Community Partners</h3>
              <ul className="space-y-3 text-gray-700 mb-6">
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-purple-600 mt-1"></i>
                  <span>Faith-based organizations</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-purple-600 mt-1"></i>
                  <span>Educational institutions</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-purple-600 mt-1"></i>
                  <span>Other non-profit organizations</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-purple-600 mt-1"></i>
                  <span>Government agencies</span>
                </li>
              </ul>
              <Button variant="primary" className="w-full">
                <i className="ri-team-line mr-2"></i>
                Community Partnership
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section 
        className="py-20 bg-cover bg-center relative"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Community%20members%20of%20all%20backgrounds%20joining%20hands%20around%20a%20growing%20tree%20of%20life%2C%20symbolic%20bridge%20connecting%20different%20communities%2C%20warm%20golden%20hour%20lighting%2C%20unity%20and%20collective%20action%20for%20social%20change%2C%20diverse%20group%20working%20together%20for%20common%20purpose%2C%20inspiring%20hope%20and%20transformation&width=1920&height=800&seq=cta-unity&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-green-900/80 to-blue-900/80"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Ready to Make a Difference?</h2>
          <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
            Every action, no matter how small, contributes to breaking the cycle and building hope. Join us today and be part of the solution.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="secondary" size="lg">
              <i className="ri-phone-line mr-2"></i>
              Contact Us Today
            </Button>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-blue-900">
              <i className="ri-mail-line mr-2"></i>
              Get Our Newsletter
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
